<template>
  <div class="constructeurs-heatmap needResize" :class="{'fullscreen': fullscreen}" v-if="result">
    <Info @fullscreen="onFullScreen" title="constructeur.title" text="constructeurHeatmap.info" ></Info>
    <div class="constructeur-title">
      <h3>{{$t('constructeurHeatmap.title')}}</h3>
      <h2>{{$t('constructeurHeatmap.description')}}</h2>
      <div class="metricSelector"> <v-select v-model="metricSelect" :options="metrics" :clearable="false" :searchable="false"></v-select></div>
      <div class="metricSelector"> <v-select v-model="topSelect"    :options="tops"    :clearable="false" :searchable="false"></v-select></div>
      <div class="metricSelector"> <v-select v-model="sortBySelect" :options="sortBys"  :clearable="false" :searchable="false"></v-select></div>
    </div>
    <div class="main-content-constructeurs-heatmap" :class="{'full': fullscreen}" ref="mainContent">
      <apexchart ref="realtimeChart" type="heatmap" :height="chartHeight" :options="chartOptions" :series="selectedChartData"></apexchart>
    </div>
  </div>
</template>

<script>
  import Info from './Info.vue'
  export default {
    name: 'Constructeur',
    components: {
      Info
    },
    props: {
      result: Object,
    },
    data() {
      return {
        fullscreen: false,
        metric: null,
        top: null,
        sortBy: null,
        chartHeight: 700,
        metrics: [
          {value:'ca', label:'CA TTC (en €)'},
          {value:'margin', label:'Marge HT (en €)'},
          {value:'customers', label:'Nombre de Clients'},
          {value:'caByCustomer', label:'CA (TTC) par client'},
          {value:'marginByCustomer', label:'Marge (HT) par client'},
        ],
        tops: [
          {value: 5, label: "Top 5"},
          {value: 10, label: "Top 10"},
          {value: 15, label: "Top 15"},
          {value: 25, label: "Top 25"},
        ],
        sortBys: [
          {value:'values', label:'Valeurs décroissantes'},
          {value:'names', label:'Ordre alphabétique'},
        ],
        minYear: 0,
        maxYear: 20,
        chartOptions: {
          plotOptions: {
            heatmap: {
              shadeIntensity: 0.75
            }
          },
          chart: {
            height: 600,
            type: 'heatmap',
            redrawOnWindowResize: true,
            redrawOnParentResize: true
          },
          xaxis: {
            title: {
              text: 'Age du véhicule',
            },
            categories: [...Array(21).keys()]
          },
          yaxis: {
            labels: {
              minWidth: 0,
              maxWidth: 200,
            },
            title: {
              text: 'CA TTC (en €)',
            }
          },
          dataLabels: {
            enabled: false
          },
          colors: ["#008FFB"]
        },
        chartDataSortedByValues: null,
        chartDataSortedByNames:  null,
        selectedChartData: null
      }
    },
    methods: {
      onFullScreen() {
        this.fullscreen = !this.fullscreen
      },
      getMetric: function (data) {
        if (this.metricSelect.value === 'ca') {
          return data.totalAmountTtc.value;
        }
        if (this.metricSelect.value === 'margin') {
          return data.profBrandHt.value;
        }
        if (this.metricSelect.value === 'customers') {
          return data.prIdBu.value;
        }
        if (this.metricSelect.value === 'caByCustomer') {
          return data.totalAmountTtc.value / data.prIdBu.value;
        }
        if (this.metricSelect.value === 'marginByCustomer') {
          return data.profBrandHt.value / data.prIdBu.value;
        }
        return 0
      },
      chartDataProcess() {
        if (!this.result || !this.result.aggregations || !this.result.aggregations["to-bills"] || !this.result.aggregations["to-bills"].bills.vehicles) {
          this.selectedChartData = []
          return
        }

        let buckets = this.result.aggregations["to-bills"].bills.vehicles.brand_model.buckets.filter(elt => !elt.key.startsWith('XXX') && elt.per_year.buckets.length > 0)
        
        let result = []
        for (let topNumber=0 ; topNumber<this.topSelect.value ; topNumber++) {
          if(buckets[topNumber]) {
              let row = {
                name: buckets[topNumber].key,
              data: []  
            }

            let rowBuckets = buckets[topNumber].per_year.buckets
            let incompleteData = []
            rowBuckets.forEach(bucket => {
              if(bucket.key >= this.minYear && bucket.key <= this.maxYear) {
                incompleteData.push(bucket)
              }
            });

            for (let year = this.minYear ; year <= this.maxYear ; year++) {
              let yearData = incompleteData.filter(e => e.key === year)
              if(yearData.length > 0) {
                let dataRow = this.getMetric(yearData[0].prIdBu)
                let roundedDataRow = Math.round(dataRow*100)/100;
                row.data.push(roundedDataRow)
              } 
              else {
                row.data.push(0)
              }
            }
            result.push(row)
          }
        }

        if (this.sortBy && this.sortBy.value === 'names') {
          this.selectedChartData = result.sort((a,b) => (a.name > b.name) ? -1 : ((b.name > a.name) ? 1 : 0))
        } else {
          this.selectedChartData = result.reverse()
        }
      }
    },
    computed: {
      metricSelect: {
        get: function(){
          return this.metric || this.metrics[0];
        },
        set: function(evt){
          this.metric = evt
          this.chartOptions.yaxis.title.text = evt.label
          this.chartDataProcess()
          // On est obligé de cloner les options avant de les appliquer car la fonction updateOptions modifie le
          // format des options passées en paramètres de manière indésirable.
          let chartOptionsClone = JSON.parse(JSON.stringify(this.chartOptions))
          this.$refs.realtimeChart.updateOptions(chartOptionsClone);
        }
      },
      topSelect: {
        get: function(){
          return this.top || this.tops[3];
        },
        set: function(evt){
          this.top = evt
          this.chartDataProcess()
          if (evt.value > 10) {
            this.chartHeight = 700
          } else {
            this.chartHeight = 450
          }
        }
      },
      sortBySelect: {
        get: function(){
          return this.sortBy || this.sortBys[0];
        },
        set: function(evt){
          this.sortBy = evt
          this.chartDataProcess()
        }
      },
    },
    created() {
      this.chartDataProcess()
    },
    watch: {
      result: {
        // the callback will be called immediately after the start of the observation
        immediate: true,
        handler (val, oldVal) {
          this.chartDataProcess()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/constructeur_heatmap.sass"
</style>
